import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

function CareerRouteHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/panel/recruitment/careers/jobs');
  }, []);

  return <Outlet />;
}

export default CareerRouteHandler;
